// Module
var code = `<div class="max-size" resolution-mode check-idle ng-switch="vm.moduleToLoad"> <div class="max-size" ng-switch-when="7Terminal.AnonymousApp"> <div class="max-size"> <t-anonymous-app></t-anonymous-app> </div> </div> <div num-pad num-pad-visibility="default" ng-if="vm.showNumpad"> </div> <ui-view ng-if="vm.showInstallPage"> </ui-view> </div>`;
// Exports
var _module_exports =code;;
var path = '/modules/bootstrap/app.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;